export default __webpack_public_path__ + "static/media/loubna.de2e4165.png";